import React from 'react';
import { Text, View } from 'react-native-web';

//= ========================================================================

const OperatorCard = ({
  globJSON, text, withIcon, numberColumns, contentAlignedCenter,
}) => {
  const { colors } = globJSON.configurations.theme;

  const myStyles = {
    card: {
      marginBottom: 10,
      flexBasis: `${100 / numberColumns - numberColumns}%`,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 4 : 9,
      border: `solid 0.6px ${colors.border_color}`,
      marginEnd: numberColumns > 1 && `${numberColumns}%`,
      flexDirection: 'row',
      minHeight: numberColumns > 1 ? 30 : 40,
      paddingLeft: !contentAlignedCenter && 14,
    },
    text: {
      fontSize: numberColumns > 1 ? 9.3 : 11.6,
      tintColor: colors.cta_font_color,
      marginHorizontal: !withIcon && contentAlignedCenter && 'auto',
      marginVertical: 'auto',
      fontFamily: 'Quicksand-Semibold',
    },
    image: {
      width: numberColumns > 1 ? 23 : 28,
      borderRadius: 3.5,
      backgroundColor: colors.menu_top_area_color,
      margin: numberColumns > 1 ? 2 : 5,
    },
  };

  return (
    <View style={myStyles.card}>
      {withIcon && <View style={myStyles.image} />}
      <Text style={myStyles.text}>{text}</Text>
    </View>
  );
};
export default OperatorCard;
